import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NAVY = '#0D1B35';
const BLUE = '#0066CC';

export const CreateOrder: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ maxWidth: 640, mx: 'auto', mt: { xs: 4, sm: 8 }, px: 3 }}>
      <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 3, p: { xs: 4, sm: 6 }, textAlign: 'center' }}>
        <Typography variant="h3" sx={{ color: NAVY, mb: 1 }}>En desarrollo</Typography>
        <Typography sx={{ color: 'text.secondary', mb: 3, maxWidth: 480, mx: 'auto' }}>
          Estamos rediseñando el módulo de creación de pedidos para alinearlo con el nuevo catálogo. Por ahora, los doctores pueden seguir buscando medicamentos y emitiendo recetas físicas.
        </Typography>
        <Button variant="contained" sx={{ bgcolor: BLUE }} onClick={() => navigate('/doctor/medications')}>
          Volver a buscar medicamentos
        </Button>
      </Paper>
    </Box>
  );
};
